export default __webpack_public_path__ + "static/media/hmd_background_m1.33d14dfd.jpg";